import React, { useEffect } from "react";
import PropTypes from "prop-types";
import FacilityGeneralInfoContainer from "features/facility/edit/generalData/components/info/FacilityGeneralInfoContainer";
import FacilitySublimitsContainer from "features/facility/edit/sublimits/components/FacilitySublimitsContainer";
import { loadFacilityHeader } from "features/facility/wizard/actionCreators";
import { useSelector, useDispatch } from "react-redux";
import { getFacilityHeader } from "features/facility/wizard/selectors";

const headerStatusEqual = (prev, next) => prev.loading === next.loading && prev.loaded === next.loaded;

const FacilityApprovalContainer = ({ folderId, history }) => {
  const dispatch = useDispatch();
  const facilityId = useSelector(state => state.currentFolder.header.facilityId);
  const facilitySiteId = useSelector(state => state.currentFolder.header.facilitySiteId);

  const { loaded, content: facilityHeader } = useSelector(state => getFacilityHeader(state, facilityId), headerStatusEqual);

  useEffect(() => {
    if (facilityHeader.loaded || facilityHeader.loading || !facilityId) return;
    dispatch(loadFacilityHeader(facilityId, facilitySiteId));
  }, [facilityId, facilitySiteId, dispatch, loaded]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <FacilityGeneralInfoContainer
        documentId={facilityId}
        siteId={facilitySiteId}
        folderId={folderId}
        history={history}
      />
      {facilityId && <FacilitySublimitsContainer documentId={facilityId} siteId={facilitySiteId} />}
    </React.Fragment>
  );
};

FacilityApprovalContainer.propTypes = {
  folderId: PropTypes.number,
  history: PropTypes.object
};

export default FacilityApprovalContainer;
